import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import ModalComponent from "../../../../../Components/Modais";
import { IComponentModal } from "../../../../../Components/Modais/IModalComponent";
import { ListarEmpreendimentosController } from "../../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import CadastrarFormularioProduto from "../CadastrarFormularioProduto";
import Table from "../../../../../Components/Table";
import ListarProdutosEFormulario from "../ListarProdutosEFormulario";

export default function ListagemFormulariosGestaoProdutos() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const {
        value: lstEmpreendimentos,
        loading: lstEmpreendimentosLoading,
        execute: listarEmpreendimentos,
    } = useAsyncEffect(ListarEmpreendimentosController);

    const tableColumns: Array<ColumnDescription> = [
        {
            dataField: "DS_EMPREENDIMENTO",
            text: "Produtos",
            headerFormatter: () => (
                <div className="d-flex align-items-center justify-content-between">
                    <span>Produtos</span>
                    <button
                        className="btn btn-success font-weight-bold mr-2"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                Component: () => (
                                    <CadastrarFormularioProduto
                                        setShow={setShow}
                                        setModal={setModal}
                                        listarEmpreendimentos={
                                            listarEmpreendimentos
                                        }
                                    />
                                ),
                                IconHeader: faPlus,
                                headerComponent: "Cadastrar Formulário",
                                size: "lg",
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faPlus} size="lg" /> Cadastrar
                        Formulário
                    </button>
                </div>
            ),
            formatter: (_, row) => (
                <ListarProdutosEFormulario
                    updateList={listarEmpreendimentos}
                    produto={row}
                />
            ),
        },
    ];

    return (
        <div>
            <Table
                data={lstEmpreendimentos ?? []}
                loading={lstEmpreendimentosLoading}
                columns={tableColumns}
                keyField="ID_EMPREENDIMENTO"
                bordered={false}
                hover={false}
            />

            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </div>
    );
}
